import React from 'react';
import { Controller, useFormContext, ValidateResult } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SelectOptionType } from '../../dialog';
import { InputSelect } from '../../input';

type ComponentProps<T> = {
  name: string;
  label: string;
  options: SelectOptionType<T>[];
  value?: string;
  disabled?: boolean;
  isRequired?: boolean;
  reverse?: boolean;
  handleChange?: (val) => void;
  validation?: (val: string) => ValidateResult | Promise<ValidateResult>;
};

export const SelectInputController = <T,>({
  name,
  label,
  options,
  value,
  disabled,
  isRequired,
  reverse,
  validation,
  handleChange,
}: ComponentProps<T>) => {
  const { t: tc } = useTranslation('common');
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        ...(isRequired ? { required: tc('isRequired') as string } : {}),
        ...(validation
          ? {
              validate: validation,
            }
          : {}),
      }}
      render={({ field, fieldState: { error } }) => {
        return (
          <InputSelect
            onChange={handleChange || field.onChange}
            value={value !== undefined ? value : field.value}
            options={options}
            label={label}
            name={field.name}
            {...(disabled !== undefined ? { disabled: disabled } : {})}
            {...(error ? { errorMessage: error.message } : {})}
            reverse={reverse}
          />
        );
      }}
    />
  );
};
